module.exports = __webpack_public_path__ + "static/media/discount.dd768219.png";